export default __webpack_public_path__ + "static/media/mint.eef85018.jpeg";